// Single-line inline legend rendered beneath the dual-tier timeline.
// Five swatch+label pairs covering the most common timeline states; the
// full eight-state vocabulary stays accessible via the row pills and tooltips.

interface InlineLegendItem {
  dotClass: string;
  border?: string;
  label: string;
  detail?: string;
}

const ITEMS: ReadonlyArray<InlineLegendItem> = [
  { dotClass: "bg-emerald-600", label: "Paid" },
  {
    dotClass: "bg-white dark:bg-slate-800",
    border: "border border-emerald-500",
    label: "Accepted (awaiting payment)",
  },
  { dotClass: "bg-sky-500", label: "Delivered" },
  { dotClass: "bg-slate-400", label: "Upcoming" },
  {
    dotClass: "bg-red-500",
    label: "Late",
    detail: "past due, not yet delivered",
  },
  {
    dotClass: "bg-amber-500",
    label: "Delivered late",
    detail: "delivered after due date",
  },
];

export default function TimelineLegendInline() {
  return (
    <section
      data-testid="timeline-legend-inline"
      aria-label="Timeline status legend"
      className="flex flex-wrap items-center gap-x-4 gap-y-1.5 border-t border-slate-200 pt-3 dark:border-slate-700"
    >
      {ITEMS.map((item) => (
        <span
          key={item.label}
          className="inline-flex items-center gap-1.5 text-caption text-slate-600 dark:text-slate-400"
        >
          <span
            aria-hidden="true"
            className={`inline-block h-2.5 w-2.5 rounded-full ${item.dotClass}${item.border ? ` ${item.border}` : ""}`}
          />
          <span className="font-medium text-slate-700 dark:text-slate-300">
            {item.label}
          </span>
          {item.detail && (
            <span className="text-slate-500 dark:text-slate-400">
              — {item.detail}
            </span>
          )}
        </span>
      ))}
    </section>
  );
}
